import { Space } from '@procurify/ui'

import { TextLoader } from '@webapp/core/components/ContentLoader'

export const EditExpenseLineItemDrawerLoader = () => {
  return (
    <Space size='xlarge' align='stretch'>
      <Space direction='horizontal' justify='space-between'>
        <TextLoader height={48} width={48} />
        <TextLoader height={48} width={48} />
        <TextLoader height={48} width={48} />
        <TextLoader height={48} width={48} />
        <TextLoader height={48} width={48} />
        <TextLoader height={48} width={48} />
      </Space>

      <Space.Divider />
      <TextLoader height={30} width={72} />

      <Space direction='horizontal'>
        <Space.Item width={1 / 2}>
          <TextLoader height={36} />
        </Space.Item>
        <Space.Item width={1 / 2}>
          <TextLoader height={36} />
        </Space.Item>
      </Space>
      <TextLoader height={36} />
      <TextLoader height={36} />
      <Space.Divider />
      <Space align='end'>
        <Space direction='horizontal' justify='end'>
          <Space.Item width={1 / 3}>
            <TextLoader height={36} />
          </Space.Item>
          <Space.Item width={1 / 3}>
            <TextLoader height={36} />
          </Space.Item>
        </Space>
        <Space.Item width={2 / 3}>
          <TextLoader height={36} />
        </Space.Item>
        <Space.Item width={1 / 3}>
          <TextLoader height={36} />
        </Space.Item>
      </Space>
    </Space>
  )
}
